var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"mr-2",attrs:{"color":_vm.active ? 'success' : 'primary'},on:{"click":function($event){return _vm.$emit('click')}}},on),[_vm._v(" "+_vm._s(_vm.name)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }